import { isMobilePhone } from 'validator';

const ValidateMobileNumber = (value) => {
  return (!isMobilePhone(value, 'en-GB')) ? "Invalid mobile number" : ""
};

export default ValidateMobileNumber;
